export default "__VITE_ASSET__d2ffbb3e__"